import React from "react";

const apps = [
    { tag: "01", title: "Bakery & confectionery", desc: "Mango, beetroot, apple and ginger bring colour and flavour without artificial flavouring." },
    { tag: "02", title: "Health drinks & smoothies", desc: "Banana, spinach, beetroot and pineapple — single-ingredient stack-ready bases." },
    { tag: "03", title: "Baby food & cereals", desc: "Soft-dried apple, banana and carrot — no added sugar, no salt, no fillers." },
    { tag: "04", title: "Nutraceuticals", desc: "Ginger, papaya, jackfruit and beetroot for capsule, sachet and gummy formulations." },
    { tag: "05", title: "Cosmetics & skincare", desc: "Papaya, guava and beetroot for natural masks, scrubs and personal care brands." },
    { tag: "06", title: "Seasonings & snacks", desc: "Onion, garlic, tomato — the savoury backbone of crisps, mixes and ready meals." },
];

const Applications = () => {
    return (
        <section data-testid="applications-section" className="py-24 md:py-36 bg-sun-cream relative">
            <div className="container-x">
                <div className="grid grid-cols-12 gap-6 mb-12 md:mb-16">
                    <div className="col-span-12 md:col-span-6">
                        <div className="overline mb-4">— End uses</div>
                        <h2 className="font-heading text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-[-0.02em] text-sun-ink">
                            One pantry,
                            <br />
                            <span className="display-italic text-gradient">six</span> industries.
                        </h2>
                    </div>
                    <div className="col-span-12 md:col-span-6 self-end">
                        <p className="text-sun-inkSoft text-base leading-relaxed max-w-md">
                            Our powders are flexible by design. Same SKU — infinite end uses, from
                            a children's biscuit factory in Riyadh to a face-mask brand in Berlin.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
                    {apps.map((a) => (
                        <div
                            key={a.tag}
                            data-testid={`app-${a.tag}`}
                            className="bg-white border border-sun-line rounded-3xl p-8 md:p-10 group hover:bg-sunrise hover:text-white hover:border-transparent transition-all duration-500"
                        >
                            <div className="font-mono text-xs uppercase tracking-[0.32em] text-sun-orange group-hover:text-white">
                                / {a.tag}
                            </div>
                            <h3 className="mt-6 font-heading text-3xl md:text-4xl leading-[1.05] tracking-tight">
                                {a.title}
                            </h3>
                            <p className="mt-4 text-sm leading-relaxed opacity-80">
                                {a.desc}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Applications;
